module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2187/img/storefront-header-blobs.svg"